(function() {
    'use strict';

    angular.module( APP_ID )
        .component( 'wellingtonPromo', {
            bindings: {
                content:    '<'
            },
            templateUrl: 'app/views/partials/content/wellington-promo.html',
            controllerAs: 'vm',

            renderingOptions: {
                'wellington-promo': {
                    inputs:    [
                        'content="::content.asset_contents"'
                    ],
                    classes:       [ 'block block__image-promo' ],
                    parentClasses: [ 'highlighted' ]
                }
            }
        });
})();
